import { render, staticRenderFns } from "./salesData.vue?vue&type=template&id=1c46a76a&scoped=true&"
import script from "./salesData.js?vue&type=script&lang=js&"
export * from "./salesData.js?vue&type=script&lang=js&"
import style0 from "./salesData.vue?vue&type=style&index=0&id=1c46a76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c46a76a",
  null
  
)

export default component.exports